module.exports = __webpack_public_path__ + "img/tour-55.0e7c0040.png";